export const referencesPerTypeToReferences = (referencesPerType) => {
  const references = [];

  for (const key in referencesPerType) {
    for (const reference of referencesPerType[key]) {
      // TODO: Should filename be different according to the key
      // Forbidden placeholders: pass through with just uri+type+key so the
      // backend keeps the link to the referenced entity intact. Other fields
      // are unknown to us because the proxy refused to return them.
      references.push({
        uri: reference.url ?? reference.uri,
        fileName: reference.filename ?? null,
        link: reference.link ?? null,
        type: key,
      });
    }
  }

  return references;
};

export const referencesPerTypeToPatchQuery = (referencesPerType) => {
  const toEncodedUri = (value) =>
    value != null ? encodeURIComponent(value) : null;

  const references = [];

  for (const key in referencesPerType) {
    for (const reference of referencesPerType[key]) {
      references.push({
        // TODO: HORRIBLE DESIGN, GET ONE KEY, either URI or URL
        uri: toEncodedUri(reference.uri ?? reference.url),
        fileName: toEncodedUri(reference.filename),
        link: toEncodedUri(reference.link),
        // Fall back to the loop key when the entry has no .type (e.g. a
        // forbidden placeholder), so the backend still knows what kind of
        // reference it is.
        type: toEncodedUri(reference.type ?? key),
      });
    }
  }

  return references;
};
